import type { TOC } from '@ember/component/template-only';
import type { WithBoundArgs } from '@glint/template';
import dateFormat from 'garaje/helpers/date-format';
import type GroupInvite from 'garaje/models/group-invite';

interface DatetimeCellSignature {
  Args: {
    row: GroupInvite;
    isLoading?: boolean;
  };
  Element: HTMLDivElement;
}

export function createCurriedDatetimeCell(isLoading?: boolean): WithBoundArgs<typeof DatetimeCell, 'isLoading'> {
  const CurriedDatetimeCell: TOC<{ Args: { row: GroupInvite }; Element: HTMLDivElement }> = <template>
    <DatetimeCell @row={{@row}} @isLoading={{isLoading}} ...attributes />
  </template>;

  return CurriedDatetimeCell as WithBoundArgs<typeof DatetimeCell, 'isLoading'>;
}

const DatetimeCell: TOC<DatetimeCellSignature> = <template>
  <div ...attributes data-test-group-invites-list-datetime-cell>
    {{#if @isLoading}}
      <div class="skeleton-loading-boxes">
        <div class="text w-32 h-4 rounded-md mb-2">&nbsp;</div>
        <div class="text w-24 h-4 rounded-md">&nbsp;</div>
      </div>
    {{else if @row.expectedArrivalTime}}
      <div class="flex flex-col">
        <span>{{dateFormat @row.expectedArrivalTime "MMM d, yyyy"}}</span>
        <span class="text-xs text-carbon-30">{{dateFormat @row.expectedArrivalTime "h:mm aaa"}}</span>
      </div>
    {{else}}
      <span class="text-carbon-30">—</span>
    {{/if}}
  </div>
</template>;

export default DatetimeCell;
